import { FC } from 'react';

import { AddDocumentIcon } from '../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '../../../../components/hover-card/index';
import { useFormat } from '../../../../hooks/index';
import { eventFormType, EventTypeBackend } from '../../../../types/events.types';
import { sharePlanTypeTitle } from '../../../../types/pool-plans.types';
import { getS3FileOriginalName } from '../../../../utils/get-s3file-original-name.util';
import {
  mergeEventAndRecordFileLinks,
  resolveTransactionRowDocumentLinks,
} from '../../utils/resolve-event-document-links.util';
import { CardProps } from './transaction-card-variants.types';
import { TransactionOverviewItem } from './transaction-overview-item';
import { TransactionTitleItem } from './transaction-title-item';

export const NewPlan: FC<CardProps> = ({ event, openFileUploadModal }) => {
  const { format } = useFormat();
  if (event.type !== EventTypeBackend.NEW_PLAN) return <></>;
  const { type, pool, createdAt, sharePlan } = event;
  const { allLinks: documentFileLinks } = resolveTransactionRowDocumentLinks(
    mergeEventAndRecordFileLinks(event),
    {
      docusignFileLinks: event.docusignFileLinks,
      event,
      linkedSignatureFileLink: event.signatureSummary?.linkedSignatureFileLink,
    },
  );

  return (
    <div className="flex flex-col divide-y divide-gray-100 rounded-md shadow-sm">
      <TransactionTitleItem createdAt={format(createdAt, 'dd/MM/yyyy')} name={sharePlan?.name} />
      <TransactionOverviewItem
        title={<AppFormattedMessage id="TRANSACTION_TYPE" />}
        value={<AppFormattedMessage id={eventFormType[type]} />}
      />
      <TransactionOverviewItem
        title={<AppFormattedMessage id="EQUITY_POOL" />}
        value={pool?.name}
      />
      <TransactionOverviewItem
        title={<AppFormattedMessage id="EQUITY_PLAN_TYPE" />}
        value={sharePlanTypeTitle?.[sharePlan?.type]}
      />

      {documentFileLinks.length > 0 && (
        <TransactionOverviewItem
          title={<AppFormattedMessage id="DOCUMENTS" />}
          value={
            <HoverCard>
              <HoverCardTrigger onClick={() => openFileUploadModal(documentFileLinks)}>
                <AddDocumentIcon className="cursor-pointer" />
              </HoverCardTrigger>

              <HoverCardContent
                className="max-w-[360px] rounded-lg bg-[#101828] px-3 py-2"
                side="top"
              >
                <span className="block w-full truncate p-0 text-label-md font-[550] text-white">
                  {documentFileLinks.length === 1
                    ? getS3FileOriginalName(documentFileLinks[0])
                    : `Download ${documentFileLinks.length} files`}
                </span>
              </HoverCardContent>
            </HoverCard>
          }
        />
      )}
    </div>
  );
};
